<template>
  <div class="bra-pg">
    <progress-bar/>

    <div id="input-form" class="input-form">
      <div id="bra-input-group" class="form-group">
        <span class="form-input-title-label">Your bra size</span>

        <bra-size-region-dropdown class="bra-size-region-dropdown inline pull-right" v-model="sizeRegion"/>
      </div>

      <component :is="braSizesComponent"
                 :invalid-bust="$v.bust.$error"
                 :invalid-cup="$v.cup.$error"></component>

      <navigation/>
    </div>
  </div>
</template>

<script>
import Navigation from "../../Navigation";
import ProgressBar from "../../ProgressBar";
import BraSizeRegionDropdown from "../../form/BraSizeRegionsDropdown";
import AmericanBraSizes from './bra/AmericanBraSizes';
import {validationMixin} from 'vuelidate';
import {required} from 'vuelidate/lib/validators';
import {mapFields} from 'vuex-map-fields';

export default {
  name: "BraComponent",

  components: {
    BraSizeRegionDropdown,
    AmericanBraSizes,
    ProgressBar,
    Navigation,
  },

  mixins: [validationMixin],

  computed: {
    ...mapFields('userSelections', [
      'female.bra.sizeRegion',
      'female.bra.bust',
      'female.bra.cup',
    ]),

    braSizesComponent() {
      if (this.sizeRegion === 'american') return 'AmericanBraSizes';
      return null;
    },
  },

  methods: {
    submit() {
      return new Promise(resolve => {
        this.$v.$touch();

        if (!this.$v.$invalid) {
          resolve();
        }
      });
    },
  },

  validations: {
    bust: {
      required,
    },
    cup: {
      required,
    },
  },
};
</script>
